/*
* jquery-match-height 0.7.0 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,i=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),n=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-i(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(n-a))<=o?r[r.length-1]=s.add(e):r.push(e),n=a}),r},n=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=n(e);if(o.remove){var i=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(i)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.0",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=i,r._parseOptions=n,r._apply=function(e,o){var s=n(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),d=h.parents().filter(":hidden");return d.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),d.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),n=0;if(s.target)n=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),i=e.css("display");"inline-block"!==i&&"flex"!==i&&"inline-flex"!==i&&(i="block");var a={
display:i};a[s.property]="",e.css(a),e.outerHeight(!1)>n&&(n=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=i(e.css("border-top-width"))+i(e.css("border-bottom-width")),o+=i(e.css("padding-top"))+i(e.css("padding-bottom"))),e.css(s.property,n-o+"px"))})}),d.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),i=o.attr("data-mh")||o.attr("data-match-height");i in e?e[i]=e[i].add(o):e[i]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(i,a){if(a&&"resize"===a.type){var n=t(window).width();if(n===e)return;e=n;
}i?-1===o&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi),t(window).bind("load",function(t){r._update(!1,t)}),t(window).bind("resize orientationchange",function(t){r._update(!0,t)})});

/*!
 * hoverIntent v1.8.0 // 2014.06.29 // jQuery v1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */
 
/* hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */
(function($) {
    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {

        // default configuration values
        var cfg = {
            interval: 50,
            sensitivity: 8,
            timeout: 250
        };

        if ( typeof handlerIn === "object" ) {
            cfg = $.extend(cfg, handlerIn );
        } else if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // instantiate variables
        // cX, cY = current X and Y position of mouse, updated by mousemove event
        // pX, pY = previous X and Y position of mouse, set by mouseover and polling interval
        var cX, cY, pX, pY;

        // A private function for getting mouse position
        var track = function(ev) {
            cX = ev.pageX;
            cY = ev.pageY;
        };

        // A private function for comparing current and previous mouse position
        var compare = function(ev,ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            // compare mouse positions to see if they've crossed the threshold
            if ( Math.sqrt( (pX-cX)*(pX-cX) + (pY-cY)*(pY-cY) ) < cfg.sensitivity ) {
                $(ob).off("mousemove.hoverIntent",track);
                // set hoverIntent state to true (so mouseOut can be called)
                ob.hoverIntent_s = true;
                return cfg.over.apply(ob,[ev]);
            } else {
                // set previous coordinates for next time
                pX = cX; pY = cY;
                // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
                ob.hoverIntent_t = setTimeout( function(){compare(ev, ob);} , cfg.interval );
            }
        };

        // A private function for delaying the mouseOut function
        var delay = function(ev,ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            ob.hoverIntent_s = false;
            return cfg.out.apply(ob,[ev]);
        };

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // copy objects to be passed into t (required for event object to be passed in IE)
            var ev = $.extend({},e);
            var ob = this;

            // cancel hoverIntent timer if it exists
            if (ob.hoverIntent_t) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); }

            // if e.type === "mouseenter"
            if (e.type === "mouseenter") {
                // set "previous" X and Y position based on initial entry point
                pX = ev.pageX; pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $(ob).on("mousemove.hoverIntent",track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                if (!ob.hoverIntent_s) { ob.hoverIntent_t = setTimeout( function(){compare(ev,ob);} , cfg.interval );}

                // else e.type == "mouseleave"
            } else {
                // unbind expensive mousemove event
                $(ob).off("mousemove.hoverIntent",track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                if (ob.hoverIntent_s) { ob.hoverIntent_t = setTimeout( function(){delay(ev,ob);} , cfg.timeout );}
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
})(jQuery);

var headerHeight = 0;

jQuery(document).ready(function($){
  headerHeight = $('body > header').outerHeight();

  $(window).on('resize',function(){

    headerHeight = $('body > header').outerHeight();

  });
  $(window).load(function(){
    headerHeight = $('body > header').outerHeight();
  });

  $(window).scroll(function(){

  var scrolltop = $(window).scrollTop();
    if ($(this).scrollTop() > 1) {  
      $('body').addClass("sticky");
      
      /*
      var product_offsettop = 38; //todo - set to height of header
      if (scrolltop > product_offsettop) {
        var w = $('#collection-alt-page #sidebar-left').width();
        $('#collection-alt-page #sidebar-left').css('width',w+'!important').addClass('stick');
      } else {
        $('#collection-alt-page #sidebar-left').removeAttr('style').removeClass('stick');
      }
      */
                  
    } else {
      $('body').removeClass("sticky");
      //$('#collection-alt-page #sidebar-left').removeAttr('style').removeClass('stick');
    }

    if(scrolltop>headerHeight){
      $('body').addClass('past-header');
    }
    else{
      $('body').removeClass('past-header');
    }

  });
  
  /*
  //fix dropdown slider jerk using customslide fn:
  http://stackoverflow.com/questions/7244382/slide-subsequent-elements-as-well-when-using-jquery-uis-slide-effect
  */
  
  $('.section-header').click(function(e) {
    if($(window).width() < 768){
    e.preventDefault();
    var nav = $(this).closest('nav');
    
      // $('#stockists #rest-of-world').hide();
      // $('#stockists>ul').hide();
    
    $('.section-list').hide();
    $('.section-list', nav).toggle('slide', { direction: 'up' }, 500);
    }
    else{
       $('.section-list').show();
    }
  });
  
  //product detail page
  $('.modal-body').enscroll({
    showOnHover: false,
    verticalTrackClass: 'track3',
    verticalHandleClass: 'handle3'
  });
  
  /*
  $('.wishlist-pro-wrapper-page .accordion-section-title').addClass('active');
  $('.wishlist-pro-wrapper-page .accordion-section-content').addClass('open');
  */
  
  if ($('#collection-alt-page').length){
    //$('#sidebar-left').stickit({top:0, screenMinWidth:992});
    
    $('#collection-alt-page .grid__item a').click(function(e) {
      e.preventDefault();
        var parent = $(this).parent();
        var index = $('.grid__item').index(parent);
      
        var slider = $('.product-single__hero #slider').data('flexslider');
        slider.flexAnimate(index); 
      
        $('#collection-alt-page .grid__item a').removeClass('active');
    $(this).addClass('active');
    });
            
  }
  
  if ($('#stockists').length) {
    
    $('#stockists #sidebar-left a').click(function(e) {
      e.preventDefault();
      
      $('#stockists #sidebar-left .section-list').hide();
      
        var nav = $(this).closest('nav').attr('id');
      var id = $(this).data('id');
        var title = $(this).text();
        
        if (id == 'rest-of-world' || id == 'online' || id == 'ONLINE') $('#stockists nav#state').hide();
        if (id == 'australia') {
          $('#stockists nav#state').show();
          $('#stockists nav#state .sidebar-title').html('NSW');
          id = 'NSW';
        }
      
        $('#stockists nav#'+nav+' .sidebar-title').html(title);
      
      $('#stockists>ul').hide();
      $('#stockists #'+id).fadeIn('slow');
    });
    
    //init stockist page
    var id = 'NSW'; //needs to be nsw
    $('#stockists #rest-of-world').hide();
    $('#stockists nav#region .sidebar-title').text('Australia');
    $('#stockists nav#state .sidebar-title').text('NSW');
    $('#stockists #'+id).fadeIn('slow');
    
  }
  
  //jump to required url
  $('select.jump-to-url').on('change', function(e){ 
    if (this.value.length > 0) window.location.href = this.value;
  });
  
  $('.selectpicker').selectpicker({
    style: 'btn-info'
  });

  
  $('input, textarea').placeholder();

  $('.promo-images > .grid__item > a').matchHeight();

  
  
});

jQuery(document).ready(function($) {

  var wW = $(window).width();

  // mobile menu toggle
  $('.menu-toggle').click(function() {
    $('.nav-bar').toggle();
        $('html').toggleClass('hide-scroller');
  });

  if ( wW <= 962 && wW > 768 ) {
    $('ul.sm-simple > li.has-dropdown > a').click(function(e) {

      e.preventDefault();
      if( $(this).parent().hasClass('active') ) {
        $(this).parent().removeClass('active');
      } else {
        $(this).parent().addClass('active').siblings().removeClass('active');
      }
      e.stopImmediatePropagation();
    });
  }

        $('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > div', function(e) {
            var li = $(this).parent();
      if( li.hasClass('active') ) {
        li.toggleClass('active');
      }else{
        li.addClass('active').siblings().removeClass('active');
      }
      e.stopImmediatePropagation();
    });


  // mega-nav custom scripts
  if ( wW <= 768 ) {
        $('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > a', function(e) {
            e.stopImmediatePropagation();
            var href = $(this).attr('href');
      if( href == '#' ) {
                var li = $(this).parent();
        if( li.hasClass('active') ) {
          li.removeClass('active');
                }else{
          li.addClass('active').siblings().removeClass('active');
        }
      }
    });
  }
  

 
    
   $(window).resize(function() {
    var wWr = $(window).width();
    if ( wWr > 768 ) {
           
      $('li.has-dropdown.bottom').remove();
    } else {
           
      $('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', 'auto');
     

          }
      
        if ( wWr <= 768 ) {
        $('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > a', function(e) {
            e.stopImmediatePropagation();
            var href = $(this).attr('href');
      if( href == '#' ) {
                var li = $(this).parent();
        if( li.hasClass('active') ) {
          li.removeClass('active');
                }else{
          li.addClass('active').siblings().removeClass('active');
        }
      }
    });
  }
  });

$('li[class*="has-mega-dropdown"] ').hoverIntent(function(){
  $this = $(this);
    $this.find('.mega-wrapper').stop(true,true).fadeIn(function(){
    }).addClass('active');
},function(){
   $this = $(this);
  $this.find('.mega-wrapper').stop(true,true).fadeOut(350,function(){
    $this.removeClass('active');
  });
});
  
$('form[role="search"] [type="submit"]').on('click',function(e){
  var $searchField = $(this).closest('form').find('[type="search"]');
  var searchQuery = $searchField.val();
  // console.log(searchQuery);
  if( searchQuery === ""){
    e.preventDefault();
    $searchField.focus();
  }
  else{
    return true;
  }
});

 $('.header-bar__search-input').on('keyup',function(){
   console.log($(this).val());
 });

});

